import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { initGoogleAnalytics } from 'analytics/analytics';
import { brazeChangeUser, brazePgaViewEvent } from 'analytics/braze';

import {
    toggleModal,
    togglePopup,
    toggleSpinner,
    updateAuthPromoBlock,
    updateCurrentSiteSection,
    updateMessages,
    updateReduxAction,
    toggleSnackBar,
} from 'actions/appAction';
import { updateAuth } from 'actions/authAction';
import { initCalculator } from 'actions/calculatorAction';
import { updateCards } from 'actions/cardsAction';
import { chatBlockStatus, toggleChat } from 'actions/chatAction';
import { setExtra } from 'actions/extraAction';
import { setNewForm } from 'actions/formAction';
import { setCheque, setHistory } from 'actions/historyAction';
import { updateJsMessages, updatePageMessages } from 'actions/messageAction';

import { UpdateReduxService } from 'services/UpdateReduxService';

import { COUNTRY_OF_RESIDENCE } from 'constants/amplitude/AmplitudeParamName';

import update from 'helpers/Immutability';

import amplitude from 'amplitude-js';

import { AMPLITUDE_API_KEY } from './AmplitudeUtils';
import WSChat from '../chat/WSChat';

const PageWrapper = styled.div`
    background-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.black};
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export default function BasePage(PageComponent) {
    class BasePageComponent extends React.Component {
        constructor(props) {
            super(props);

            this.updateReduxService = new UpdateReduxService(props.lang);
            this.updateReduxService.setMessageAction(props.updateJsMessages, props.updatePageMessages);
            this.updateReduxService.setHistoryAction(props.setCheque, props.setHistory);
            this.updateReduxService.setChatAction(props.chatBlockStatus);
            this.updateReduxService.setAuthAction(props.updateAuth);
            this.updateReduxService.setFormAction(props.setNewForm);
            this.updateReduxService.setCalculatorAction(props.initCalculator);
            this.updateReduxService.setAppAction(
                props.toggleModal,
                props.togglePopup,
                props.toggleSpinner,
                props.updateAuthPromoBlock,
                props.updateCurrentSiteSection,
                props.updateMessages,
            );
            this.updateReduxService.setExtraAction(props.setExtra);
            this.updateReduxService.setCardsAction(props.updateCards);
            this.updateReduxService.setStateOptions(props.stateOptions);

            const data = __isBrowser__ ? window.__INITIAL_DATA__ : props.staticContext ? props.staticContext.json : props.data;
            this.state = { data: data, loading: props.updateRedux };
        }

        componentDidMount() {
            if (this.props.updateRedux) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country).then((data) => {
                    this.setState(
                        update(this.state, {
                            data: { $set: data },
                            loading: { $set: false },
                        }),
                    );
                });
            } else {
                this.props.updateReduxAction();
            }
            window.scrollTo(0, 0);
            if (__isBrowser__) {
                if (document.readyState === 'complete') {
                    this.initAnalytics();
                } else {
                    window.addEventListener('load', this.initAnalytics, { once: true });
                }
            }
            if (__isProd__) {
                const userId = this.props.auth?.phone ? this.props.auth?.phone : null;
                const userCountry = this.props.userCountry?.nameEn;
                amplitude.getInstance().init(AMPLITUDE_API_KEY, userId, {
                    serverZone: 'EU',
                    serverZoneBasedApi: true,
                });
                if (this.props.webAppVersion) {
                    amplitude.getInstance().setVersionName(this.props.webAppVersion);
                }
                if (userCountry) {
                    amplitude.getInstance().setUserProperties({ [COUNTRY_OF_RESIDENCE]: userCountry });
                }
            } else {
                amplitude.getInstance = () => {
                    return {
                        setUserId: () => {},
                        setUserProperties: () => {},
                        logEvent: () => {},
                    };
                };
            }
            if (__isBrowser__) {
                brazePgaViewEvent(window.location.href, document.title, this.props.app, this.props.auth, this.props.lang);
                if (this.props.auth?.ballId) {
                    brazeChangeUser(this.props.auth?.ballId);
                } else {
                    sessionStorage?.removeItem('isLoggedIn');
                }
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.lang !== prevProps.lang) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country);
            }
        }

        initAnalytics = () => {
            const activateAnalytics = __isProd__;
            initGoogleAnalytics(activateAnalytics);
        };

        render() {
            return (
                <PageWrapper>
                    <PageComponent {...this.props} loading={this.state.loading} data={this.state.data} />
                    {this.props.stateOptions?.showChat && <WSChat />}
                </PageWrapper>
            );
        }
    }

    const mapStateToProps = (state) => {
        return {
            app: state.app,
            updateRedux: state.app.updateRedux,
            auth: state.auth,
            lang: state.language.lang,
            country: state.app.country,
            showBrexitTerms: state.extra.showBrexitTerms,
            userCountry: state.extra?.userCountry,
            webAppVersion: state.extra?.webAppVersion,
        };
    };

    return connect(mapStateToProps, {
        updateReduxAction,
        togglePopup,
        toggleModal,
        updatePageMessages,
        updateJsMessages,
        updateAuthPromoBlock,
        setCheque,
        setHistory,
        setNewForm,
        initCalculator,
        updateMessages,
        toggleSpinner,
        updateAuth,
        updateCards,
        setExtra,
        updateCurrentSiteSection,
        chatBlockStatus,
        toggleChat,
        toggleSnackBar,
    })(BasePageComponent);
}
